import { render, staticRenderFns } from "./notifications-model.vue?vue&type=template&id=13ad9921&scoped=true"
import script from "./notifications-model.vue?vue&type=script&lang=js"
export * from "./notifications-model.vue?vue&type=script&lang=js"
import style0 from "./notifications-model.vue?vue&type=style&index=0&id=13ad9921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad9921",
  null
  
)

export default component.exports